import React from 'react';
import PropTypes from 'prop-types';

import { Container, Title, TrackingContainer } from './styles';
import TrackingCard from './TrackingCard';

function TrackingList({ classes, trackingType, trackingList }) {
    return (
        <Container className={classes}>
            <Title>Rastreamento {trackingType}</Title>

            <TrackingContainer>
                <ul>
                    {trackingList.map((historico, index) => (
                        <TrackingCard
                            key={String(index)}
                            historico={historico}
                        />
                    ))}
                </ul>
            </TrackingContainer>
        </Container>
    );
}

TrackingList.propTypes = {
    classes: PropTypes.string.isRequired,
    trackingType: PropTypes.string.isRequired,
    trackingList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TrackingList;
